export enum ERROR_TYPE {
    USER_AWAITING = 'USER_AWAITING',
    WRONG_EMAIL_PASSWORD = 'WRONG_EMAIL_PASSWORD',
}
